export default __webpack_public_path__ + "static/media/infographic-reward-success.411b90ac.svg";